(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["badge-container"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.__sdBadgeContainerInit) return;
    window.__sdBadgeContainerInit = true;

    function hydrate() {
      var containers = document.querySelectorAll('[data-dynamic-badges]');
      var search = new URLSearchParams(window.location.search);

      containers.forEach(function (container) {
        var keys = (container.dataset.params || '').split(',').map(function (s) { return s.trim(); });
        var defaults = (container.dataset.defaults || '').split(',').map(function (s) { return s.trim(); });
        var badges = container.querySelectorAll('.badge-container__badge');

        badges.forEach(function (badge, index) {
          var key = keys[index];
          var value = (key && search.get(key)) || defaults[index] || '';
          var textEl = badge.querySelector('.badge-container__text');
          if (value) {
            if (textEl) textEl.textContent = value;
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrate);
    } else {
      hydrate();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["interactive-infographic-default"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var INIT_ATTR = 'data-interactive-infographic-init';

  function initSection(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.hasAttribute(INIT_ATTR)) return;
    sectionEl.setAttribute(INIT_ATTR, '');

    var sectionId  = sectionEl.dataset.sectionId;
    var tabs       = Array.from(sectionEl.querySelectorAll('[role="tab"]'));
    var panels     = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));
    var markers    = Array.from(sectionEl.querySelectorAll('.interactive-infographic__marker'));
    var dots       = Array.from(sectionEl.querySelectorAll('.interactive-infographic__dot'));
    var panelsWrap = sectionEl.querySelector('.interactive-infographic__panels');
    var mobileMq   = window.matchMedia('(max-width: 749px)');

    if (tabs.length === 0) return;

    /* ── Core activate function ── */
    function activate(newIndex, opts) {
      opts = opts || {};
      // newIndex is 1-based (matching data-feature-index)
      tabs.forEach(function (tab, i) {
        var isActive = (i + 1) === newIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        tab.classList.toggle('is-active', isActive);
      });

      panels.forEach(function (panel, i) {
        var isActive = (i + 1) === newIndex;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      markers.forEach(function (marker) {
        var markerIndex = parseInt(marker.dataset.featureIndex, 10);
        marker.classList.toggle('is-active', markerIndex === newIndex);
      });

      dots.forEach(function (dot) {
        var dotIndex = parseInt(dot.dataset.featureIndex, 10);
        dot.classList.toggle('is-active', dotIndex === newIndex);
      });

      // On mobile, bring the matching card into the slider viewport. Only when
      // requested (tab/marker/dot activation), never from a manual swipe sync.
      if (opts.scrollCarousel && mobileMq.matches && panelsWrap) {
        var card = panels[newIndex - 1];
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    }

    /* ── Tab click ── */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.featureIndex, 10);
        activate(idx);
        tab.focus();
      });
    });

    /* ── Marker click ── */
    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        var idx = parseInt(marker.dataset.featureIndex, 10);
        activate(idx, { scrollCarousel: true });
        // Desktop: move focus to the matching pill (keyboard feedback). On
        // mobile the tablist is hidden, so don't focus a non-visible control.
        if (!mobileMq.matches) {
          var matchTab = tabs[idx - 1];
          if (matchTab) matchTab.focus();
        }
      });
    });

    /* ── Dot click (mobile slider pagination) ── */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.featureIndex, 10);
        activate(idx, { scrollCarousel: true });
      });
    });

    /* ── Sync active state to manual swipes of the card slider (mobile) ── */
    if ('IntersectionObserver' in window && panelsWrap && panels.length) {
      var swipeObserver = new IntersectionObserver(function (entries) {
        if (!mobileMq.matches) return; // slider only exists on mobile
        var winner = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting &&
              (!winner || entry.intersectionRatio > winner.intersectionRatio)) {
            winner = entry;
          }
        });
        if (winner && winner.intersectionRatio >= 0.6) {
          var idx = panels.indexOf(winner.target) + 1;
          if (idx >= 1) activate(idx); // no scrollCarousel — the user is scrolling
        }
      }, { root: panelsWrap, threshold: [0.6] });

      panels.forEach(function (panel) { swipeObserver.observe(panel); });
    }

    /* ── Keyboard nav on tablist (roving tabindex — auto-activate) ── */
    tabs.forEach(function (tab) {
      tab.addEventListener('keydown', function (evt) {
        var currentIdx = parseInt(tab.dataset.featureIndex, 10);
        var newIdx;

        switch (evt.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            evt.preventDefault();
            newIdx = (currentIdx % tabs.length) + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            evt.preventDefault();
            newIdx = ((currentIdx - 2 + tabs.length) % tabs.length) + 1;
            break;
          case 'Home':
            evt.preventDefault();
            newIdx = 1;
            break;
          case 'End':
            evt.preventDefault();
            newIdx = tabs.length;
            break;
          default:
            return;
        }

        activate(newIdx);
        var nextTab = tabs[newIdx - 1];
        if (nextTab) nextTab.focus();
      });
    });
  }

  /* ── Bootstrap all instances on page load ── */
  function initAll() {
    document.querySelectorAll('[data-section-type="interactive-infographic"]').forEach(function (el) {
      initSection(el);
    });
  }

  /* ── Re-init on Shopify theme editor section:load ── */
  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('[data-section-type="interactive-infographic"]');
    if (el) {
      el.removeAttribute(INIT_ATTR);
      initSection(el);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jump-links-default"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.__jumpLinksInit) return;
    window.__jumpLinksInit = true;

    document.addEventListener('click', function (evt) {
      var link = evt.target.closest('.jump-links__bar a');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      var id = href.slice(hashIndex + 1);
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return; // cross-page or missing target → let the browser handle it

      evt.preventDefault();

      var bar = link.closest('[data-jump-links]');
      var offset = bar ? parseInt(bar.getAttribute('data-scroll-offset'), 10) : 0;
      if (isNaN(offset)) offset = 0;

      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, left: 0, behavior: 'smooth' });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["okendo-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
  function bindScrollButtons() {
    document.querySelectorAll('[data-sd-okendo-scroll-to-reviews]:not([data-sd-scroll-bound])').forEach(function (btn) {
      btn.setAttribute('data-sd-scroll-bound', '');
      btn.addEventListener('click', function () {
        var target = document.querySelector('[data-oke-widget]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindScrollButtons);
  } else {
    bindScrollButtons();
  }
})();

(function () {
  var elements = document.querySelectorAll('[data-sd-okendo-reviews]');
  if (!elements.length) return;

  var fetched = {};
  elements.forEach(function (el) {
    var productId = el.dataset.productId;
    var userId = el.dataset.okendoUserId;
    if (!userId || !productId || fetched[productId]) return;
    fetched[productId] = true;

    var url = 'https://api.okendo.io/v1/stores/' + userId + '/products/shopify-' + productId + '/review_aggregate';

    fetch(url, { headers: { 'okendo-api-version': '2025-02-01' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var count = data.reviewCount || 0;
        var total = data.reviewRatingValuesTotal || 0;
        if (count === 0) return;

        var avg = (total / count).toFixed(1);
        var avgNum = parseFloat(avg);
        var fullStars = Math.floor(avgNum);
        var partialPct = Math.round((avgNum - fullStars) * 100);
        var starPath = 'M7.613 12.186a.614.614 0 0 1 .775 0l2.726 1.645c.568.343 1.268-.167 1.118-.813l-.724-3.1a.615.615 0 0 1 .255-.738l2.41-2.087c.5-.434.233-1.258-.429-1.314l-3.17-.27a.615.615 0 0 1-.511-.454L8.69 2.129c-.258-.61-1.123-.61-1.381 0L6.07 5.056a.615.615 0 0 1-.511.454l-3.17.27c-.662.056-.93.88-.429 1.314l2.41 2.087a.615.615 0 0 1 .254.737l-.723 3.1c-.151.647.55 1.157 1.117.813l2.726-1.645Z';

        document.querySelectorAll('[data-sd-okendo-reviews][data-product-id="' + productId + '"]').forEach(function (el, idx) {
          el.hidden = false;
          var starColor = el.dataset.starColor || '#ED9A4A';
          var unfilledColor = el.dataset.unfilledColor || '#D1D5DB';
          var countFormat = el.dataset.countFormat || '[count] reviews';

          var ratingEl = el.querySelector('[data-sd-okendo-rating]');
          if (ratingEl) ratingEl.textContent = avg;

          var countEl = el.querySelector('[data-sd-okendo-count]');
          if (countEl) countEl.textContent = countFormat.replace('[count]', count.toLocaleString());

          var starsContainer = el.querySelector('.okendo-reviews__stars');
          if (starsContainer) {
            var starH = parseInt(starsContainer.style.height, 10) || 16;
            var html = '';
            for (var j = 1; j <= 5; j++) {
              if (j <= fullStars) {
                html += '<svg width="' + starH + '" height="' + starH + '" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="' + starPath + '" fill="' + starColor + '"/></svg>';
              } else if (partialPct > 0 && j === fullStars + 1) {
                var gid = 'ps-' + productId + '-' + idx + '-' + j;
                html += '<svg width="' + starH + '" height="' + starH + '" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="' + gid + '"><stop offset="' + partialPct + '%" stop-color="' + starColor + '"/><stop offset="' + partialPct + '%" stop-color="' + unfilledColor + '"/></linearGradient></defs><path d="' + starPath + '" fill="url(#' + gid + ')"/></svg>';
              } else {
                html += '<svg width="' + starH + '" height="' + starH + '" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="' + starPath + '" fill="' + unfilledColor + '"/></svg>';
              }
            }
            starsContainer.innerHTML = html;
          }
        });
      })
      .catch(function () {});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-default"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initPolicyToc(section) {
    var bodyEl = section.querySelector('[id^="policy-body-"]');
    var tocList = section.querySelector('[id^="policy-toc-list-"]');

    if (!bodyEl || !tocList) return;

    var headings = bodyEl.querySelectorAll('h2');
    if (!headings.length) return;

    // Inject anchor IDs into headings (idempotent)
    headings.forEach(function (h, idx) {
      if (!h.id) {
        var slug = (h.textContent || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        h.id = slug || ('section-' + idx);
      }
    });

    // Build TOC list items
    tocList.innerHTML = '';
    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'policy__toc-item';

      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;

      // Smooth scroll
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Update URL without jump
          if (history.pushState) {
            history.pushState(null, '', '#' + h.id);
          }
        }
      });

      li.appendChild(a);
      tocList.appendChild(li);
    });

    // Scroll-spy via IntersectionObserver
    if (!window.IntersectionObserver) return;

    var tocItems = tocList.querySelectorAll('.policy__toc-item');
    var headingArray = Array.from(headings);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = headingArray.indexOf(entry.target);
          if (idx === -1 || !tocItems[idx]) return;
          if (entry.isIntersecting) {
            tocItems.forEach(function (item) { item.classList.remove('is-active'); });
            tocItems[idx].classList.add('is-active');
          }
        });
      },
      { rootMargin: '-10% 0px -85% 0px', threshold: 0 }
    );

    headings.forEach(function (h) { observer.observe(h); });
  }

  // After ~300px scroll, drop the sticky `top` from 100px to 40px. CSS handles
  // the transition; this just toggles the modifier class.
  function initStickyTopAdjust() {
    var tocs = document.querySelectorAll('.policy__toc');
    if (!tocs.length) return;

    var threshold = 300;
    var ticking = false;

    function update() {
      var scrolled = window.scrollY > threshold;
      tocs.forEach(function (toc) {
        toc.classList.toggle('is-scrolled', scrolled);
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  function init() {
    document.querySelectorAll('[data-section-type="policy"]').forEach(initPolicyToc);
    initStickyTopAdjust();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor hot-reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.dataset.sectionType === 'policy') {
      initPolicyToc(section);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
